import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@cloudscape-design/components/box';
import Container from '@cloudscape-design/components/container';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { formatPct } from '@/features/dashboard-finance/formatters';

/** KPI de stickiness (DAU/MAU) do último dia; `null` mostra "—". */
export function StickinessCard({
  stickinessPct,
}: {
  stickinessPct: number | null;
}): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <Container>
      <SpaceBetween size="xxs">
        <Box variant="awsui-key-label">{t('product.cards.stickiness')}</Box>
        <Box variant="h1">{stickinessPct == null ? '—' : formatPct(stickinessPct, 1)}</Box>
        <Box fontSize="body-s" color="text-status-inactive">
          {t('product.cards.stickinessHint')}
        </Box>
      </SpaceBetween>
    </Container>
  );
}
